import JsonEditorVue from 'json-editor-vue'
import 'vanilla-jsoneditor/themes/jse-theme-dark.css'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(JsonEditorVue, {

  })
})
